module.exports = __webpack_public_path__ + "static/media/308.3a27943e.svg";